<!-- Generator: Adobe Illustrator 28.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg enable-background='new 0 0 250 205' height='205px' version='1.1' viewBox='0 0 250 205' width='400px'
     x='0px' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' y='0px'>
<g id="graphics">
	<path d="M176.5,164.5h-2.6h-44.4l0,34h-11.3h-10.7l0-34H62.6h-3.1V41.3
		l2-1.8h5.6c3.3,0.8,6.3,2.3,8.4,4.8l35.7,44.5c4.1,4.2,10.9,4.2,15,0l35.3-44.4c2-2.6,5.1-4.1,8.4-3.9h4.5l2.1,1.8L176.5,164.5z" fill="#9A9A9A" stroke="#707070" stroke-miterlimit="10"/>
  <path d="M176.6,29.2l-50.9,51.1
		c-3.8,3.7-9.9,3.7-13.8,0l-69.2-68l5.7-5.7l66.3,64.2c2.1,2.1,5.5,2.1,7.6,0l48.4-47.1L176.6,29.2z" fill="#DADADA" stroke="#707070" stroke-linejoin="round" stroke-miterlimit="10"/>
  <line fill="none" stroke="#285172" stroke-miterlimit="10" x1="75.5" x2="75.5" y1="44" y2="128"/>
  <line fill="none" stroke="#285172" stroke-miterlimit="10" x1="161.5" x2="161.5" y1="44" y2="128"/>
  <path d="M115.5,83.4c6.8,6.7,13.7,13.3,20.5,20" fill="none" stroke="#285172" stroke-miterlimit="10"/>
  <line fill="none" stroke="#285172" stroke-miterlimit="10" x1="177.1" x2="196.1" y1="29.9" y2="48.4"/>
  <g>
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="79.6" x2="157.4" y1="118.5" y2="118.5"/>
      <g>
				<polygon fill="#285172" points="80.3,121 76,118.5 80.3,116 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="156.7,121 161,118.5 156.7,116 				"/>
			</g>
		</g>
	</g>
  <g>
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="133" x2="184.5" y1="94.8" y2="42.4"/>
      <g>
				<polygon fill="#285172" points="135.3,96.1 130.5,97.4 131.7,92.6 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="185.7,44.7 187,39.9 182.2,41.2 				"/>
			</g>
		</g>
	</g>
</g>
  <g id="texts">
	<rect fill="none" height="36" width="68.7" x="180.3" y="61"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="minimalLegLenght" transform="matrix(1 0 0 1 180.3223 69.8818)">{{legLength}}</text>
    <rect fill="none" height="64" width="85" x="76" y="124"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="dieWidth" transform="matrix(1 0 0 1 103.5996 132.8906)">{{dieWidth}}</text>
</g>
</svg>

